class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetAvailableEnabled = facetForm.querySelector("[name='filter.v.availability']");
    if (facetAvailableEnabled) { 
      FacetFiltersForm.hasAvailabilityFacet = true;
     } else {
      FacetFiltersForm.hasAvailabilityFacet = false;
     }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.columnCount = "";

    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    if (urlParams.has('columncount')) {
      this.columnCount = urlParams.get("columncount");
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    FacetFiltersForm.closeAllDetails();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.closeAllDetails();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.closeAllDetails();

  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let colOptionButtons = document.querySelectorAll('.column-options .col-option');
    let productGridUl = document.querySelector('#ProductGridContainer ul#product-grid');
    
    colOptionButtons.forEach(button => {
        if (button.classList.contains('is-active')) {
            let dataValue = button.getAttribute('data-value');
            if (productGridUl && dataValue) {
                productGridUl.classList.add(`cc${dataValue}`);
            }
        }
    });
    const renderEvent = new Event("ProductGridRendered");
    document.dispatchEvent(renderEvent);
    productGridUl.classList.remove("d-none");
    FacetFiltersForm.closeAllDetails();

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      const countMatch = count.match(/\d+/); 
      if (countMatch) {
        containerDesktop.innerHTML = countMatch[0] + " products";
      } else {
        containerDesktop.innerHTML = count + " products";
      }      
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    document.querySelectorAll('.list-menu__item.facets__item').forEach((element) => {
      const isChecked = element.querySelector('input:checked');
      if (isChecked) {
        element.classList.add('checked');
      } else {
        element.classList.remove('checked');
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    FacetFiltersForm.closeAllDetails();
  }

  static closeAllDetails() {
    const allDetails = document.querySelectorAll('.facets__disclosure-vertical');

    allDetails.forEach((details) => {
      const summary = details.querySelector('summary');
      if (summary && !summary.getAttribute('data-clicked')) {
          summary.setAttribute('data-clicked', 'true');  
          summary.addEventListener('click', function(event) {
            event.preventDefault();
            var div = document.getElementById("aside-facets");
            var displayStyle = window.getComputedStyle(div, null).getPropertyValue("display");
            if (displayStyle === "none") {
              if(details.open) {
                details.open = false;
              } else {
                details.open = true;
              }
            } else {
              allDetails.forEach((innerDetails) => {
                innerDetails.open = false;
              });
              details.open = true;
            }
          });
      }
  });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.closeAllDetails();

  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    FacetFiltersForm.closeAllDetails();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
    FacetFiltersForm.closeAllDetails();
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }
  

  createSearchParams(form) {
    const formData = new FormData(form);
    let queryString = window.location.search;
    let newurlParams = new URLSearchParams(queryString);
    if (this.columnCount != '') {
      formData.append('columncount', newurlParams.get('columncount'));
    }
    let newSearchParams = new URLSearchParams(formData).toString();
    
    if (newSearchParams.includes("filter.v.option") && !newSearchParams.includes("filter.v.availability") && FacetFiltersForm.hasAvailabilityFacet) {
      newSearchParams = newSearchParams + "&filter.v.availability=1";
    }

    return newSearchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
     
    let current_sort_by_value = document.querySelector(".sort-by__item.checked").dataset.value;
    FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
    const prevSearchParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev);

        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
  
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      let completeForm = forms.join('&');
      const currentParams = new URLSearchParams(completeForm);
    
      // Collect all 'sort_by' params from prevSearchParams
      const prevSortBys = [];
      for (let [key, value] of prevSearchParams) {
        if (key === 'sort_by') {
          prevSortBys.push(value);
        }
      }
    
      // Collect all 'sort_by' params from currentParams
      const currentSortBys = [];
      for (let [key, value] of currentParams) {
        if (key === 'sort_by') {
          currentSortBys.push(value);
        }
      }
    
      // Compare prevSortBys and currentSortBys
      const sortBysAreDifferent = JSON.stringify(prevSortBys) !== JSON.stringify(currentSortBys);
    
      if (sortBysAreDifferent) {
        const newParams = new URLSearchParams();
        for (let [key, value] of currentParams) {
          if (key === 'sort_by' && value === current_sort_by_value) {
            // Skip this one
            continue;
          }
          newParams.append(key, value);
        }

        completeForm = newParams.toString();
     }

    this.onSubmitForm(completeForm, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

var toggleFiltersButtons = document.querySelectorAll("button.toggle-filters");
var filterModal = document.querySelector(".filter-modal");
var filterModalAside = document.querySelector(".filter-modal aside");
var facetsWrapperDesktop = document.querySelector("#FacetsWrapperDesktop");


var filterCloseButton = document.querySelector(".close-filter-modal");
var applyCloseButton = document.querySelector(".apply-close-btn");
var facetsContainer = document.querySelector(".facets-wrapper");
var activeFacetsContainer = document.querySelector(".active-facets");
var swipeButton = document.querySelector(".rect-container");

filterCloseButton.addEventListener("click", function(e){
  e.preventDefault();
  closeFilter(e);
});


// function sortOptionClick(event) {
//   const selectedValue = option.dataset.value;
//   let queryString = window.location.search;
//   let urlParams = new URLSearchParams(queryString);

//   if (urlParams.has('sort_by')) {
//     urlParams.set('sort_by', selectedValue);
//   } else {
//     urlParams.append('sort_by', selectedValue);
//   }
//   window.location.search = urlParams.toString();
// }

  


filterModal.addEventListener("click", function (event) {
  
  if (
    filterModal.classList.contains("active") &&
    event.target === filterModal &&
    event.target !== filterModalAside
  ) {
    closeFilter(event);
  } else if(event.target.classList.contains('apply-close-btn')) {
    event.preventDefault();
    closeFilter(event);
  } else if(event.target.classList.contains('.sort-by__item')) {

  }
});

var startY = 0;

filterModal.addEventListener("touchstart", function (event) {
  if (window.innerWidth < 750) {
    startY = event.touches[0].clientY;
  }
});


filterModal.addEventListener("touchend", function (event) {
  if (window.innerWidth < 750) {
    var endY = event.changedTouches[0].clientY;
    var deltaY = endY - startY;

    if (deltaY > 50 && event.target === filterModal && event.target !== facetsWrapperDesktop) {
      closeFilter(event);
    }

    if (deltaY > 50 && event.target === filterModal && event.target == activeFacetsContainer ) {
      closeFilter(event);
    }

  }
});

activeFacetsContainer.addEventListener("touchstart", function (event) {
  if (window.innerWidth < 750) {
    startY = event.touches[0].clientY;
  }
  event.stopImmediatePropagation();
});

activeFacetsContainer.addEventListener("touchend", function (event) {
  if (window.innerWidth < 750) {
    var endY = event.changedTouches[0].clientY;
    var deltaY = endY - startY;

    if (deltaY > 50 ) {
      closeFilter(event);
    }

  }
});


function closeFilter(e) {
  e.preventDefault();
  filterModal.classList.remove("active");
  document.body.classList.remove("overflow-hidden");
}

toggleFiltersButtons.forEach(function(button) {
  button.disabled = false;

  button.addEventListener("click", function(e) {
    e.preventDefault();

    if (!filterModal.classList.contains("active")) {

      filterModal.classList.add("active");
      document.body.classList.add("overflow-hidden");

    } else {

      filterModal.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    }
  });
});
const buttons = document.querySelectorAll('.col-option');

buttons.forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    buttons.forEach(btn => btn.classList.remove('is-active'));
    button.classList.add("is-active");
    updateColumnCount(button);
  });
});


function updateColumnCount(button) {
  const params = new URLSearchParams(window.location.search);
  const columnCount = button.dataset.value;
  const targetDiv = document.querySelector('ul#product-grid');
  params.set('columncount', columnCount);
  const allowedValues = ['1', '2', '4'];

  allowedValues.forEach(val => targetDiv.classList.remove(`cc${val}`));
        
  const newURL = `${window.location.pathname}?${params.toString()}`;
  history.pushState(null, null, newURL);

  targetDiv.classList.add(`cc${columnCount}`);
}

// Function to handle the closing of the filter.
function closeFilterFacets(e) {
  e.preventDefault();
  const filterModal = document.querySelector(".filter-modal");
  filterModal.classList.remove("active");
  document.body.classList.remove("overflow-hidden");
}

document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const columnCount = params.get('columncount');
  const targetDiv = document.querySelector('ul#product-grid');
  const allowedValues = ['1', '2', '4'];

  allowedValues.forEach(val => targetDiv.classList.remove(`cc${val}`));

  const defaultColumnCount = (window.innerWidth > 989) ? '4' : '2';

  if (allowedValues.includes(columnCount)) {
      targetDiv.classList.add(`cc${columnCount}`);
  } else {
      params.set('columncount', defaultColumnCount);
      
      const newURL = `${window.location.pathname}?${params.toString()}`;
      history.pushState(null, null, newURL);

      targetDiv.classList.add(`cc${defaultColumnCount}`);
  }

  targetDiv.classList.remove('d-none');
});


